module.exports = "pegasus_template/assets/email1-header-4.png";